export const addIdPrefix = <T extends object>(ids: T, prefix: string): T =>
  Object.keys(ids).reduce(
    (out, id) => ({
      [id]: `${prefix}-${ids[id]}`,
      ...out,
    }),
    {} as T
  );
